import {
  ABSENCES_GET,
  ABSENCE_ADD,
  ABSENCE_EDIT,
  ABSENCE_GET,
  ABSENCE_DELETE,
} from './reduxConstant';

export const absencesGet = (absences) => {
  return {
    type: ABSENCES_GET,
    payload: {
      absences,
    },
  };
};

export const absenceAdd = (absence) => {
  return {
    type: ABSENCE_ADD,
    payload: {
      absence,
    },
  };
};

export const absenceEdit = (absence) => {
  return {
    type: ABSENCE_EDIT,
    payload: {
      absence,
    },
  };
};

export const absenceGet = (absence) => {
  return {
    type: ABSENCE_GET,
    payload: {
      absence,
    },
  };
};

export const absenceDelete = (absence) => {
  return {
    type: ABSENCE_DELETE,
    payload: {
      absence,
    },
  };
};
